;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { MouseEvent, FormEvent } from "react"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  UI_STYLE_BLACK_COLOR_BUTTON,
  UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../../lib/constants"

const CustomButton = styled(Button)(() => ({
  color: "white",
  backgroundColor: UI_STYLE_BLACK_COLOR_BUTTON,
  height: "52px",
  width: "213px",
  display: "flex",
  padding: "0 25px",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontSize: "16px",
  textAlign: "center",
  letterSpacing: "0.48px",
  fontWeigth: 400,
  borderRadius: "100px",
  textTransform: "unset",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  "&:hover": {
    backgroundColor: UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  },
}))

type Props = {
  disabled: boolean
  onClick: (event: MouseEvent<HTMLButtonElement> | FormEvent) => Promise<void>
}

const SubmitPaymentButton = ({ disabled, onClick }: Props) => {
  return (
    <CustomButton disabled={disabled} onClick={onClick}>
      Add card
    </CustomButton>
  )
}

export default SubmitPaymentButton
